import { DTOgetOrderDetailedData } from 'types/orders';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

export const formatDataForOrderSummaryCard = (orderData?: DTOgetOrderDetailedData) => {
  try {
    return {
      userData: {
        firstName: orderData?.generalData?.userData?.firstName!,
        lastName: orderData?.generalData?.userData?.lastName!,
        phone: orderData?.generalData?.userData?.phoneData?.phone!,
        phoneCode: orderData?.generalData?.userData?.phoneData?.phoneCode!,
        email: orderData?.generalData?.userData?.email!
      },
      orgData: {
        organizationId: orderData?.generalData.orgData?.organizationId!,
        organizationName: orderData?.generalData.orgData?.organizationName!,
        countryCode: orderData?.generalData.orgData?.countryOrganization?.code!,
        levelSubscription: orderData?.generalData.orgData?.levelSubscription!
      }
    };
  } catch (error) {
    displayErrorNotification();
  }
};
